import React from "react";
import { shallowEqual } from "react-redux";
import Popover from "../../../../../../common-deprecated/components/popover/aem/Popover";
import { BnbLabel, useBnbOptionalLabel } from "../../../utils/labels";
import * as Button from "../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Flex from "../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import * as Text from "../../../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import Icon from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import type { PriceType } from "../../../../../../common-deprecated/types/CommonTypes";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../redux/store";
import Price from "../common/price/Price";
import * as Styles from "./styles/Summary";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { showModal } from "../../../../../../common-deprecated/redux/actions/ModalActions";
import CarDataConsolidator from "../../../../../shared-logic/utils/classes/CarDataConsolidator";
import { tyreInfoBnbLabelSelector } from "../../../utils/typedUtils";
import { showPrice } from "../../../../../../common-deprecated/settings/utils/financeSettingUtilsCommon";
import { useDispatch } from "../../../../../../shared-logic/redux/store";
import { MODAL_DETAILED_TYRE_INFO } from "../../../../../../shared-logic/utils/tyreInfoContants";

type SummaryRowWheelPropsType = {
    text: string;
    price?: PriceType;
    itemId?: string;
    onRemove?: () => void;
    popoverContent?: string | false;
};

const SummaryRowWheel = (props: SummaryRowWheelPropsType): JSX.Element => {
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const showPrices = useBnbSelector((state) => showPrice(state.commonSettings));
    const basket = useBnbSelector((state) => state.basket);
    const tyres = useBnbSelector((state) => CarDataConsolidator.getWheelTyres(basket.wheel, state.items.tyres));
    const tyreInfoLabels = useBnbSelector(tyreInfoBnbLabelSelector, shallowEqual);
    const tyreInfoFallback = useBnbOptionalLabel("tyreInfoNoEprelFallback");

    return (
        <Styles.Row>
            <Flex.Row justifyContent="space-between" flexWrap="nowrap">
                <Flex.Col>
                    <Flex.Row flexDirection="column" data-testid="summary-row-wheel">
                        <Flex.Col>
                            <span dangerouslySetInnerHTML={{ __html: props.text }} />
                            {props.popoverContent && <Popover showOnClick content={props.popoverContent} />}
                        </Flex.Col>
                        {!!tyreInfoFallback && (
                            <Flex.Col>
                                <Button.Link
                                    hasIconRight
                                    onClick={(event) => {
                                        event.preventDefault();
                                        dispatch(
                                            showModal({
                                                type: MODAL_DETAILED_TYRE_INFO,
                                                tyres,
                                                tyreInfoLabels,
                                            }),
                                        );
                                    }}
                                    color="grey7"
                                >
                                    <Text.Button>
                                        <BnbLabel label="tyreInfo" />
                                    </Text.Button>
                                    <IconWrapper>
                                        <Icon variant="info" />
                                    </IconWrapper>
                                </Button.Link>
                            </Flex.Col>
                        )}
                    </Flex.Row>
                </Flex.Col>

                {(props.price || props.onRemove) && (
                    <Styles.PriceCol>
                        {props.price && (
                            <>
                                {props.price.discount === 0 && props.price.cash === 0 ? (
                                    showPrices && <BnbLabel label="standard" />
                                ) : (
                                    <Price price={props.price} financeItemId={props.itemId} />
                                )}
                            </>
                        )}
                        {props.onRemove && (
                            <Button.Link onClick={props.onRemove}>
                                <IconWrapper>
                                    <Icon variant="close" />
                                </IconWrapper>
                            </Button.Link>
                        )}
                    </Styles.PriceCol>
                )}
            </Flex.Row>
        </Styles.Row>
    );
};

export default SummaryRowWheel;
